import { render, staticRenderFns } from "./SnoozeSwitcher.vue?vue&type=template&id=b47ed4e0&scoped=true&"
import script from "./SnoozeSwitcher.vue?vue&type=script&lang=ts&"
export * from "./SnoozeSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./SnoozeSwitcher.vue?vue&type=style&index=0&id=b47ed4e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47ed4e0",
  null
  
)

export default component.exports